import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/pro-solid-svg-icons';

import { post } from 'axios';
import { Button } from 'react-bootstrap-5';
import PdfCa from './pdf_ca';
import { PROFILE_OPTIONS, setProfileData } from '../../helpers/preview';

export default function SignCaPdf({ caFiles, readonly, signCaPath, onNext }) {
  const [saving, setSaving] = useState(false);
  const [uploadedFile, setUploadedFiled] = useState();

  const signCa = (e) => {
    e.preventDefault();

    setSaving(true);
    if (readonly) {
      setProfileData({ [PROFILE_OPTIONS.CA_SIGNED]: true });
      onNext();
    } else {
      const formData = new FormData();
      formData.append('signed_ca_file', uploadedFile);
      post(
        signCaPath,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then(() => onNext());
    }
  };

  return (
    <div>
      <div className="mb-3 text-center text-branding">
        <FontAwesomeIcon icon={faLock} size="2x"/>
      </div>
      <h5 className="mb-3 text-center">
        Sign the CA to view this document
      </h5>
      <PdfCa caFiles={caFiles} uploadedFile={uploadedFile} onFileUploaded={setUploadedFiled}/>
      {uploadedFile && (
        <div className="text-center mt-4" style={{ '--animate-duration': '1s' }}>
          <Button
            className="animate__animated animate__pulse"
            disabled={saving}
            name="submit-ca"
            variant="primary"
            onClick={signCa}
          >
            {saving ? 'Saving ...' : 'Submit'}
          </Button>
        </div>
      )}
    </div>
  );
}

SignCaPdf.propTypes = {
  caFiles: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['custom_pdf', 'custom_word']).isRequired,
    path: PropTypes.string.isRequired,
  })).isRequired,
  readonly: PropTypes.bool,
  signCaPath: PropTypes.string.isRequired,
  onNext: PropTypes.func.isRequired
};
